<div class="modal-header booking-detail-header align-items-start gap-3">

  @if (event) {
    @if (event.booking.amenity?.image) {
      <div class="amenity-icon flex-shrink-0">
        <img
          [src]="event.booking.amenity!.image!.urlFile"
          [alt]="'Icono de la amenidad ' + event.amenityName" />
      </div>
    } @else {
      <div
        class="amenity-icon is-fallback flex-shrink-0"
        [ngStyle]="{ 'background-color': event.color.border }">
        <i class="material-icons" aria-hidden="true">event</i>
      </div>
    }
  }

  <div class="header-text min-w-0 flex-grow-1">
    <h4 class="modal-title">
      {{ event?.amenityName }}
    </h4>
    <small class="text-secondary">
      {{ event?.longDateLabel }}
    </small>
  </div>

  <button
    type="button"
    class="btn-close flex-shrink-0"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body booking-detail">
  @if (event) {
    <div class="container-fluid">
      <div class="row">

        <div class="col-12 mb-3">
          <div class="d-flex flex-wrap align-items-center gap-2 min-w-0">

            <span class="state-pill" [ngClass]="event.stateClass">
              {{ event.stateLabel }}
            </span>

            @if (event.isBlocked) {
              <span class="badge text-bg-secondary">
                Reservación total
              </span>
            }

          </div>
        </div>

        <div class="col-12 mb-3">
          <div class="detail-highlight">
            <div class="row">

              <div class="col-12 col-lg-6 min-w-0">
                <div class="highlight-value">
                  {{ event.startLabel }} – {{ event.endLabel }}
                </div>
                <div class="highlight-label">
                  Horario
                </div>
              </div>

              <div class="col-12 col-lg-6 min-w-0 mt-3 mt-lg-0">
                @if (event.guests > 0) {
                  <div class="highlight-value">
                    {{ event.guests }}
                  </div>
                } @else {
                  <div class="highlight-empty">
                    Sin invitados
                  </div>
                }
                <div class="highlight-label">
                  Invitados
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="section-title">
            Domicilio
          </div>
          <div class="row">

            <div class="col-12 col-lg-4 mb-3 min-w-0">
              <small class="detail-label">Calle</small>
              <div class="detail-value">
                {{ event.streetName }}
              </div>
            </div>

            <div class="col-12 col-lg-4 mb-3 min-w-0">
              <small class="detail-label">Número</small>
              <div class="detail-value">
                {{ event.houseNumber }}
              </div>
            </div>

            <div class="col-12 col-lg-4 mb-3 min-w-0">
              <small class="detail-label">Propietario</small>
              @if (event.ownerName) {
                <div class="detail-value">
                  {{ event.ownerName }}
                </div>
              } @else {
                <div class="detail-value is-empty">
                  —
                </div>
              }
            </div>

          </div>
        </div>

        <div class="col-12">
          <p class="detail-meta">
            Creada el <b>{{ event.createdAtLabel }}</b>
            @if (event.createdByName) {
              por <b>{{ event.createdByName }}</b>
            } @else {
              <span class="is-empty">(sin registro de quién la creó)</span>
            }
          </p>
        </div>

        @if (!hasActions) {
          <div class="col-12">
            <p class="detail-note">
              Esta reservación ya ocurrió. Solo puede consultarse.
            </p>
          </div>
        }

      </div>
    </div>
  }
</div>

@if (hasActions) {
  <div class="modal-footer booking-detail-footer">

    @if (googleCalendarEnabled) {
      <a
        class="btn btn-outline-secondary d-inline-flex align-items-center justify-content-center gap-2 me-auto"
        target="_blank"
        rel="noopener noreferrer"
        [href]="googleCalendarUrl">
        <i class="material-icons" aria-hidden="true">event_available</i>
        Agregar a Google Calendar
      </a>
    }

    @if (cancelEnabled) {
      <button
        type="button"
        class="btn btn-outline-danger"
        (click)="cancel()">
        Cancelar reservación
      </button>
    }

    @if (deleteEnabled) {
      <button
        type="button"
        class="btn btn-danger"
        (click)="delete()">
        Eliminar reservación
      </button>
    }

  </div>
}
